// safe-text.pipe.ts
import { Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'sanitizeText',
  standalone: true
})
export class SanitizeTextPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(value: string): string {
    if (!value) return '';
    return this.sanitizer.sanitize(SecurityContext.HTML, value) || '';
  }
}
